import React, { Component } from 'react'
import classnames from 'classnames'
import Card from '@material-ui/core/Card'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import { Col, Row } from 'react-flexbox-grid'
import { connect } from 'react-redux'
import { fetchHCSA } from '../../redux/actions/hcsaActions'
import { injectIntl } from 'react-intl'
import TableRow from './Hsca/TableRow'
import TransactionHistory from './Hsca/TransactionHistory'
import AllocationHistory from './Hsca/AllocationHistory'
import ClaimsHistory from './Hsca/ClaimsHistory'
import { Colors } from '../../theme'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import DropDownStyles from '../../styles/components/dropdown'

import Loading from '../Loading'
import { push } from 'connected-react-router'
import DoughnutChart, { Chart } from 'react-chartjs-2'
import { localize, getLocale } from '../../util/Localizer'
import { formatCurrency } from '../../util/CurrencyFormatter'
import QuestionLink from '../../controls/QuestionLink'
import Config from '../../Config'

class HealthCareSpendingAccount extends Component {
  constructor () {
    super()
    this.benefitPeriodChange = this.benefitPeriodChange.bind(this)
    this.state = {
      currentKey: null,
      selectedLabel: localize('pages.hcsa.doughnut.available'),
      selectedValue: null
    }
  }
  componentDidMount () {
    this.props.fetchHCSA()
    const self = this
    Chart.pluginService.register({
      afterEvent: function (chart, event) {
        if (event.type === 'click') {
          const segments = chart.getElementsAtEvent(event)
          const winWidth = window.innerWidth
          let defaultRadius = chart.outerRadius
          let addRadiusMargin = 10

          if (winWidth <= 416) {
            addRadiusMargin = 5
          }

          if (segments[0]) {
            const chartData = segments[0]['_chart'].chart.config.data.datasets[0].data
            const segmentIndex = segments[0]['_index']
            const segmentValue = Number(chartData[segmentIndex])
            const segmentLabel = segmentIndex === 0 ? localize('pages.hcsa.doughnut.available') : localize('pages.hcsa.doughnut.spent')

            chart.outerRadius = defaultRadius
            chart.update()
            segments[0]['_model'].outerRadius = defaultRadius + addRadiusMargin

            self.setState({
              selectedLabel: segmentLabel,
              selectedValue: segmentValue
            })
          } else {
            chart.outerRadius = defaultRadius
            chart.update()
          }
        }
      }
    })
  }

  benefitPeriodChange (event, key) {
    const period = key.props.value
    const benefitPeriods = this.props.hcsaData
    const topInfo = benefitPeriods.find((benefitPeriod) => benefitPeriod.benefitPeriod === period)
    const selectedValue = topInfo.currentBalance
    const selectedLabel = localize('pages.hcsa.doughnut.available')

    this.setState({
      currentKey: period,
      selectedLabel,
      selectedValue
    })
  }

  getRandomInt (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  render () {
    const { classes = {} } = this.props

    const benefitPeriods = this.props.hcsaData
    if (!benefitPeriods || this.props.Loading || !benefitPeriods.map) {
      return (<Loading message={localize('common.loadingContent')} />)
    }
    if (this.props.error) {
      return (
        <p>{this.props.error}</p>
      )
    }

    const keys = benefitPeriods.map((benefitPeriod) => benefitPeriod.benefitPeriod)
    const currentKey = (this.state && this.state.currentKey) || keys[0]
    const topInfo = benefitPeriods.find((benefitPeriod) => benefitPeriod.benefitPeriod === currentKey)
    const defaultVal = topInfo.currentBalance
    const defaultLabel = localize('pages.hcsa.doughnut.available')
    let chartPadding = 20
    const winWidth = window.innerWidth
    if (winWidth <= 416) {
      chartPadding = 5
    }

    const options = {
      layout: {
        padding: chartPadding
      },
      animation: {
        duration: 500
      }
    }

    const data = {
      labels: [localize('pages.hcsa.doughnut.available'), localize('pages.hcsa.doughnut.spent')],
      datasets: [{
        data: [topInfo.currentBalance, topInfo.totalClaimsPaidAmount],
        backgroundColor: [
          Colors.Chart.primaryColor,
          Colors.Chart.secondaryColor
        ]
      }]
    }
    // MA - has to be a better way to do this but it works :)
    const li3 = localize('common.hcsa.content.point3')
    const li4 = localize('common.hcsa.content.point4')
    const content = <div>
      <p>{localize('common.hcsa.content')}</p>
      <ul>
        <li>{localize('common.hcsa.content.point1')}</li>
        <li>{localize('common.hcsa.content.point2')}</li>
        {li3 ? <li>{li3}</li> : null}
        {li4 ? <li>{li4}</li> : null}
      </ul>
    </div>

    const CraLink = getLocale() === 'en' ? 'http://www.cra-arc.gc.ca/menu-eng.html' : 'https://www.canada.ca/fr/agence-revenu.html'
    return (
      <Row>
        <Col xs={12} className='hcsa'>
          <h4 className='sectionHeading'>{localize('pages.hcsa.summary')}</h4>
          <QuestionLink
            title={localize('common.hcsa.whatIsHcsa')}
            content={content}
            className={classes.questionLink}
          />
          <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
            <Row between='lg' middle='xs' >
              <Col xs={12} lg={6}>
                <Row start='sm' center='xs' >
                  <Col xs={12} sm={5}>
                    <p className='title'>{localize('pages.hcsa.benefitPeriod')} </p>
                  </Col>
                  <Col {...Columns.max6} xs={12} smOffset={2}>
                    <Select
                      value={currentKey}
                      role='menu'
                      className={classes.hcsaDropdown}
                      aria-label={localize('pages.ariaLabel.dropDown')}
                      onChange={this.benefitPeriodChange}
                    >
                      {keys.map((period, i) => {
                        return <MenuItem key={period} value={period}>{period}</MenuItem>
                      })}

                    </Select>
                  </Col>
                </Row>
                <TableRow title='pages.hcsa.allocationAmount' value={formatCurrency(topInfo.allocationAmount)} />
                <TableRow title='pages.hcsa.availableFunds' value={formatCurrency(topInfo.availableFunds)} />
                <TableRow title='pages.hcsa.accruedCredits' value={formatCurrency(topInfo.accuredCredits)} />
                <TableRow title='pages.hcsa.currentBalance' value={formatCurrency(topInfo.currentBalance)} />
                <TableRow title='pages.hcsa.periodBalance' value={formatCurrency(topInfo.periodBalance)} />
                <TableRow title='pages.hcsa.carriedForwardPriorPeriod' value={formatCurrency(topInfo.carriedForwardPriorPeriod)} />
                <TableRow title='pages.hcsa.totalClaimsPaidAmount' value={formatCurrency(topInfo.totalClaimsPaidAmount)} />
              </Col>
              <Col xs={12} lgOffset={1} lg={5} first='xs' last='lg' className='centered'>
                <div className='chartContainer chartContainerDoughnut'>
                  <DoughnutChart id='charting' data={data} options={options} width={415} height={415} />
                  <div className='selectedSegment hidden-xs'>
                    <span className='bold'>{this.state.selectedLabel ? this.state.selectedLabel : defaultLabel}</span>
                    {this.state.selectedValue ? (formatCurrency(this.state.selectedValue)) : (formatCurrency(defaultVal))}
                  </div>
                  <div className='txtCenter visible-xs hidden-sm hidden-md hidden-lg selectedSegmentResponsive'>
                    <span className='bold'>{this.state.selectedLabel ? this.state.selectedLabel : defaultLabel}: </span>
                    {this.state.selectedValue ? (formatCurrency(this.state.selectedValue)) : (formatCurrency(defaultVal))}
                  </div>
                </div>
              </Col>
            </Row>
          </Card>

          {topInfo.transactionHistory.length > 0 ? <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
            <TransactionHistory transactionHistory={topInfo.transactionHistory} />
          </Card> : null}

          {topInfo.allocationHistory.length > 0 ? <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
            <AllocationHistory allocationHistory={topInfo.allocationHistory} />
          </Card> : null}

          {topInfo.claimsHistory.length > 0 ? <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
            <ClaimsHistory claimsHistory={topInfo.claimsHistory} />
          </Card> : null}

          {!Config.member.hcsa.hideCraText &&
            <Row>
              <Col lg={8} lgOffset={2}>
                <p>{localize('pages.hcsa.cra')} <a className={classnames(classes.link)} onClick={() => window.open(CraLink)}>{localize('pages.hcsa.craLink')}</a></p>
              </Col>
            </Row>
          }
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    hcsaData: state.HcsaReducer.hcsaData,
    isLoading: state.HcsaReducer.isLoading,
    error: state.HcsaReducer.isLoading
  }
}

const ConnectedHealthCareSpendingAccount = connect(mapStateToProps, {
  fetchHCSA,
  push
})(injectIntl(HealthCareSpendingAccount))

const styles = {
  ...CardStyles,
  ...DropDownStyles,
  link: {
    textDecoration: 'underline'
  },
  questionLink: {
    marginBottom: 15
  }
}

export default withStyles(styles)(ConnectedHealthCareSpendingAccount)



// WEBPACK FOOTER //
// ./src/widgets/Member/HealthCareSpendingAccount.js